import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface UserInfo {
  token: string;
  type: number;
  firstName: string;
  lastName: string;
}

interface AuthContextType {
  user: UserInfo | null;
  setUser: (user: UserInfo | null) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUserState] = useState<UserInfo | null>(() => {
    const stored = localStorage.getItem('dd_user');
    if (!stored) return null;
    try { return JSON.parse(stored); } catch { return null; }
  });

  const setUser = (u: UserInfo | null) => {
    setUserState(u);
    if (u) localStorage.setItem('dd_user', JSON.stringify(u));
    else localStorage.removeItem('dd_user');
  };

  const logout = () => setUser(null);

  return (
    <AuthContext.Provider value={{ user, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
